import { addAdditionalAccess } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { APILevelT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function consumeInviteToken(token: string, signal?: AbortSignal): Promise<string> {
  const config = await createLotusRequestConfig({ signal });
  const response = await addAdditionalAccess(APILevelT.app, { token }, config);
  const data = response.data as { message: string };
  return data.message;
}
